export enum PROGRAM_TYPES {
    EARN = 'EARN',
    BURN = 'BURN',
    TRANSFER = 'TRANSFER',
}

export const PROGRAM_TYPE_OPTIONS = [
    { id: 1, label: 'Earn', value: PROGRAM_TYPES.EARN },
    { id: 2, label: 'Burn', value: PROGRAM_TYPES.BURN },
    { id: 3, label: 'Transfer', value: PROGRAM_TYPES.TRANSFER },
];

export const PAYMENT_CURRENCY_OPTIONS = [
    { id: 1, label: "United State Dollar", value: "USD" },
    { id: 2, label: "EURO", value: "EUR" },
    { id: 3, label: "British Pound", value: "GBP" },
    { id: 4, label: "Indian Rupee", value: "INR" },
    { id: 5, label: "United Arab Emirates Dirham", value: "AED" },
    { id: 6, label: "Ethiopian Birr", value: "ETB" },
];